import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import MovieIcon from '@mui/icons-material/Movie';
import Stack from '@mui/material/Stack';
import EmptyWatchlist from './EmptyWatchlist'

function Watchlists({profile} :any) {

  const [listData, setlistData] = useState(profile.watchlists);

  function updatelistAPI(id) {
    const url =  "/watchlists/" + id;
    const msg = fetch(url, {method: 'DELETE'})
      .then(resp => resp.json)

    return msg;
  }

  function updateList(e, item) {
    e.preventDefault();
    const list = listData.filter(i => i.id !== item.id);
    updatelistAPI(item.id);
    return setlistData(list);
  }

  return (
    <div className="table-responsive border-bottom">
      <table className="table table-striped table-sm">
        <tbody>
          { listData?.map((item =>
            <tr>
              <td>{item.name}</td>
              <td>
                <form>
                  <Stack direction="row" spacing={2}>
                    <Button href={"/watchlists/" + item.id} size="small" variant="outlined" startIcon={<MovieIcon />}>View</Button>
                    <Button size="small" onClick={(e) => updateList(e, item) } variant="outlined" startIcon={<DeleteIcon />}>Delete</Button>
                  </Stack>
                </form>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Watchlists;
